/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awake_Bright_Crab_SoarInputs */

const fr_awake_bright_crab_soar = /** @type {(inputs: Awake_Bright_Crab_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les types d'événements auxquels cet utilisateur peut accéder`)
};

/**

* @param {Awake_Bright_Crab_SoarInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const awake_bright_crab_soar = /** @type {((inputs?: Awake_Bright_Crab_SoarInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awake_Bright_Crab_SoarInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_awake_bright_crab_soar(inputs)
});